// Environment Configuration
export const environment = {
  // API Configuration
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api',
  requestTimeout: parseInt(
    process.env.REACT_APP_REQUEST_TIMEOUT || '30000',
    10,
  ),

  // Caching Configuration
  cacheTTL: parseInt(process.env.REACT_APP_CACHE_TTL || '300000', 10),
  cacheMaxSize: parseInt(process.env.REACT_APP_CACHE_MAX_SIZE || '100', 10),

  // Feature Flags
  telemetryEnabled: process.env.REACT_APP_TELEMETRY_ENABLED === 'true',
  auditLogging: process.env.REACT_APP_AUDIT_LOGGING === 'true',

  // Development Configuration
  mockEnabled: process.env.REACT_APP_MOCK_ENABLED === 'true',
  mockKeycloak: process.env.REACT_APP_MOCK_KEYCLOAK === 'true',
  debugMode: process.env.REACT_APP_DEBUG_MODE === 'true',
  nodeEnv: process.env.NODE_ENV || 'development',
  reactAppEnv: process.env.REACT_APP_ENV || 'dev',

  // Static Authorization for testing
  staticAuth: process.env.REACT_APP_STATIC_AUTH || 'mock-static-key-12345',

  // Image/File Upload Base URL
  imageBaseUrl:
    process.env.REACT_APP_IMAGE_BASE_URL || 'https://stg-env.moneyfellows.com',
};

// Debug logging - always show in development, show in staging/production if debug mode enabled
const shouldLog = false; //process.env.NODE_ENV === 'development' || environment.debugMode;
if (shouldLog) {
  console.log('=== Environment Configuration ===');
  console.log(
    'REACT_APP_MOCK_KEYCLOAK (raw):',
    process.env.REACT_APP_MOCK_KEYCLOAK,
  );
  console.log('environment.mockKeycloak (parsed):', environment.mockKeycloak);
  console.log('NODE_ENV:', process.env.NODE_ENV);
  console.log('REACT_APP_ENV:', process.env.REACT_APP_ENV);
  console.log('API Base URL:', environment.apiBaseUrl);
  console.log('=================================');
}

export default environment;
